import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import faker from 'faker';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  plugins: {
    title: {
      display: true,
      text: 'Chart.js Bar Chart - Stacked',
    },
  },
  responsive: true,
  interaction: {
  //  mode: 'index' as const,
    intersect: false,
  },
  scales: {
    x: {
      stacked: true,
    },
    y: {
      stacked: true,
    },
  },
};

const labels = [ 'Birnin Gwari',
'Chikun',
'Giwa',
'Igabi',
'Ikara',
'Jaba',
'Jema’a',
'Kachia',
'Kaduna North',
'Kaduna South',
'Kagarko',
'Kajuru',
'Kaura',
'Kauru',
'Kubau',
'Kudan',
'Lere',
'Makarfi',
'Sabon Gari',
'Sanga',
'Soba',
'Zangon Kataf',
'Zaria'];

export const data = {
  labels,
  datasets: [
    {
      label: 'Indigene',
      data: labels.map(() => faker.datatype.number({ min: 0, max: 1000000 })),
      backgroundColor: 'rgb(255, 99, 132)',
      stack: 'Stack 0',
    },
    {
      label: 'Citizen',
      data: labels.map(() => faker.datatype.number({ min: 0, max: 1000000 })),
      backgroundColor: 'rgb(75, 192, 192)',
      stack: 'Stack 3',
    },
   
  ],
};

export function BarChart() {
  return <Bar options={options} data={data} />;
}
